


















































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import Swiper from "@/components/Swiper/Swiper.vue";
import { swiperSlide } from "vue-awesome-swiper";
import Scroller from "@/components/Scroller/Scroller.vue";
import SkuSection from "@/components/SkuSection/SkuSection.vue";
import SkuTitle from "@/components/SkuTitle/SkuTitle.vue";
import CoinsTitle from "@/components/SkuTitle/CoinsTitle.vue";
import CoinsTitleSeparate from "@/components/SkuTitle/CoinsTitleSeparate.vue";
import SpecialOffer from "@/components/SpecialOffer/SpecialOffer.vue";
import PostInfo from "@/components/PostInfo/PostInfo.vue";
import InsUserGallery from "@/components/PopGallery/InsUserGallery.vue";
import InsMeidaGallery from "@/components/PopGallery/InsMediaGallery.vue";
import {
  SHOW_SEARCH_OR_LOGIN,
  GETTER_CURRENT_INS_USER_INFO
} from "@/store/constants/ins_user_info_types";
import { RERESH_CURRENT_USER_INS_MEDIA } from "@/store/constants/ins_media_types";
import {
  GETTER_LIKE_OFFERS,
  GETTER_VIEW_OFFERS,
  GETTER_COMMENT_OFFERS,
  UPDATE_GX_SETTING_DATA,
  UPDATE_PAGE_SETTING_STATUS
} from "@/store/constants/setting_types";
import { Offer } from "@/services/offer/offer_handle";
import * as cg_user_types from "@/store/constants/cg_user_types";
import { payByAny } from "@/services/payment/payment_check/payment_check_logic";
import MidTab from "@/components/MidTab/MidTab.vue";
import NavBar from "@/components/NavBarNew/NavBar.vue";
import SelectUser from "@/components/SelectUser/SelectUser.vue";
import SpacerArea from "@/components/SkuTitle/SpacerArea.vue";
import { intersection_observer } from "@/utils/intersection_observer/intersection_observer";
import BottomInfo from "@/components/BottomInfo/BottomInfo.vue";
import * as cgConst from "@/api/cg/base/cg_const";
import { goToCoinStore } from "@/utils/router_helper/index";
import EventBus from "@/utils/event_bus";

@Component({
  name: "Likes",
  components: {
    MidTab,
    NavBar,
    Swiper,
    SelectUser,
    swiperSlide,
    Scroller,
    SkuSection,
    CoinsTitle,
    SkuTitle,
    CoinsTitleSeparate,
    SpecialOffer,
    PostInfo,
    InsUserGallery,
    InsMeidaGallery,
    SpacerArea,
    BottomInfo
  }
})
export default class LikeContainer extends Vue {
  @Action(SHOW_SEARCH_OR_LOGIN)
  private showSearchLogin: any;
  @Action(RERESH_CURRENT_USER_INS_MEDIA)
  private refreshCurrentUserMedia: any;
  @Action(UPDATE_GX_SETTING_DATA)
  private updateSettingData: any;
  @Getter(GETTER_CURRENT_INS_USER_INFO)
  private currentUserInfo: any;
  @Getter(GETTER_LIKE_OFFERS)
  private likeOffer: any;
  @Getter(GETTER_COMMENT_OFFERS)
  private commentOffer: any;
  @Getter(GETTER_VIEW_OFFERS)
  private viewOffer: any;
  @Getter(cg_user_types.GETTER_COINS)
  private userCoins: any;
  @Mutation(UPDATE_PAGE_SETTING_STATUS)
  private updatePageSettingStatus?: any;

  private showInsUserGallery: boolean = false; // users gallery
  private showInsMediaGallery: boolean = false; // media gallery
  private swiperHeight: any = "auto";
  private activeIndex = 0;
  private fixedTabBarShow: boolean = false; // 固定tabbar显示

  private tabsArr = [
    {
      label: "Likes",
      acitveColor: "rgb(255,59,48)",
      activeTextColor: "rgb(255,59,48)",
      imgUrl: require("@/assets/icons-file/tab/icon_likes2.png")
    },
    {
      label: "Comments",
      acitveColor: "rgb(23,195,150)",
      showDot: false,
      activeTextColor: "rgb(23,195,150)",
      imgUrl: require("@/assets/icons-file/tab/icon_comments2.png")
    },
    {
      label: "Views",
      acitveColor: "rgb(88,86,214)",
      showDot: false,
      activeTextColor: "rgb(88,86,214)",
      imgUrl: require("@/assets/icons-file/tab/icon_views2.png")
    }
  ];

  get currentUserIcon() {
    return (
      this.currentUserInfo &&
      this.currentUserInfo.ins_user_info &&
      this.currentUserInfo.ins_user_info.profile_pic_url
    );
  }

  get iapOfferList() {
    return [
      this.likeOfferBuyIap,
      this.commentOfferBuyIap,
      this.viewOfferBuyIap
    ];
  }
  get coinOfferList() {
    return [
      this.likeOfferBuyCoin,
      this.commentOfferBuyCoin,
      this.viewOfferBuyCoin
    ];
  }

  get likeOfferBuyIap() {
    return this.likeOffer.filter((item: any) => {
      return item.way === "iap";
    });
  }
  get likeOfferBuyCoin() {
    return this.likeOffer.filter((item: any) => {
      return item.way === "coin" && item.effect !== 0;
    });
  }

  get commentOfferBuyIap() {
    return this.commentOffer.filter((item: any) => {
      return item.way === "iap";
    });
  }
  get commentOfferBuyCoin() {
    return this.commentOffer.filter((item: any) => {
      return item.way === "coin" && item.effect !== 0;
    });
  }
  get viewOfferBuyIap() {
    return this.viewOffer.filter((item: any) => {
      return item.way === "iap";
    });
  }
  get viewOfferBuyCoin() {
    return this.viewOffer.filter((item: any) => {
      return item.way === "coin" && item.effect !== 0;
    });
  }

  @Watch("activeIndex")
  private watchActiveIndex(val: any) {
    console.log("watchActiveIndex", val);
    this.calcSwiperHeight(val);
  }

  private calcSwiperHeight(val: number) {
    const currentSlide: any = (this.$refs["slideRef" + val] as any).$el;
    const calcHeight = currentSlide ? currentSlide.offsetHeight + "px" : "auto";
    console.log("currentSlide", currentSlide);
    if (calcHeight && this.swiperHeight !== calcHeight) {
      this.swiperHeight = calcHeight;
    }
  }

  private buyOffer(offer: Offer) {
    payByAny({ offer });
  }

  private async refreshPost(done?: any) {
    try {
      await this.refreshCurrentUserMedia();
      done && done();
    } catch (error) {
      done && done();
    }
  }

  private intersection_observer_scroll() {
    const root_el = document.querySelector("#scroll-fixed-container");
    const target_el = (this.$refs.navTabBar as any).$el;
    //
    intersection_observer(
      root_el,
      target_el,
      ({ target_intersect, target_top, target_ratio }: any) => {
        if (target_top < 200 && target_ratio > 0) {
          // 避免ios弹性向下滚动，也会触发区域交叉
          this.fixedTabBarShow = !target_intersect;
        }
      }
    );
  }

  private toCoinStore() {
    //
    goToCoinStore();
    // 隐藏掉showInsMediaGallery
    this.showInsMediaGallery = false;
  }

  private clickUserInfo() {
    if (this.currentUserInfo) {
      this.showInsUserGallery = true;
    } else {
      this.showSearchLogin();
    }

    // 隐藏掉showInsMediaGallery
    this.showInsMediaGallery = false;
  }

  private listenPostGallerySwitchChange() {
    EventBus.$on("postGallerySwitchChange", (val: boolean) => {
      // 外层的switch永远是开的
      this.showInsMediaGallery = val;
    });
  }

  private created() {
    this.updateSettingData(cgConst.TAB_LIKE_KEYS).then(() => {
      this.updatePageSettingStatus("like");
    }).catch((e: any) => void 0);
  }

  private mounted() {
    this.$nextTick(() => {
      this.intersection_observer_scroll();
      this.calcSwiperHeight(this.activeIndex);
    });

    this.listenPostGallerySwitchChange();
  }

  private deactivated() {
    // 再次隐藏，避免回来时滚动是初始状态，但是还是显示了
    this.fixedTabBarShow && (this.fixedTabBarShow = false);
  }
}
